// extracted by mini-css-extract-plugin
module.exports = {"scrollBottom":"ScrollToBottomButton_scrollBottom__20Heo","MoveUpDown":"ScrollToBottomButton_MoveUpDown__22LIY"};